<template>
  <el-card class="data" v-loading="loading">
      <div class="data-title flex-space-between" slot="header">
      <p>Artists</p>
      <div class="float-right">
        <ArtistsFilters />
        <el-tooltip content="Insert" placement="top">
          <el-button
            type="success"
            circle
            icon="el-icon-plus"
            @click.prevent="insert()"
            class="ml10"
          ></el-button>
        </el-tooltip>
        <DialogArtist />
        </div>

    </div>
    <el-table
      :data="artists.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column type="expand" label="Details" width="100%">
        <template slot-scope="props">
          <div v-if="props.row.biography">
            <strong>Biography</strong>
            <p v-html="props.row.biography"></p>
          </div>
          <div v-if="props.row.hashtags">
            <strong>Hashtags</strong>
            <p>{{ props.row.hashtags }}</p>
          </div>
          <div v-if="props.row.press">
            <strong>Press</strong>
            <p v-html="props.row.press"></p>
          </div>
          <div class="inline-img" v-for="s in props.row.social" :key="s.url">
            <el-tag>
              <a :href="s.url" target="_blank">{{ s.type.name }}</a>
            </el-tag>
          </div>
          <br />
          <br />
          <div
            class="inline-img"
            v-for="i in props.row.images"
            :key="i.file_name"
          >
            <img
              v-if="i.file_name"
              class="gallery"
              :src="`${url}artists/${i.file_name}`"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100%">
        <template slot-scope="props">
          <img
            v-if="props.row.images.length === 1"
            class="avatar"
            :src="`${url}artists/${props.row.images[0].file_name}`"
          />
          <img
            v-else
            class="avatar"
            :src="`https://app.syncvault.com/static/apple-touch-icon.png`"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Artist name"
        prop="name"
        sortable
      ></el-table-column>
      <el-table-column label="Status" sortable align="right" prop="active">
        <template slot-scope="props">
          <el-tag v-if="props.row.active" type="success">
            Published
          </el-tag>
          <el-tag v-else type="danger">
            Not Published
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Published date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column> -->
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip
            content="Publish"
            placement="top"
            v-if="props.row.active !== 1"
          >
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-top"
              @click="publish(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            content="Unpublish"
            placement="top"
            v-if="props.row.active == 1"
          >
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-bottom"
              @click="unpublish(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Open on SyncVault" placement="left">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-zoom-in"
              @click="openSB(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Edit" placement="right">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="artists.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="artists.total"
    ></el-pagination>
  </el-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ArtistsFilters from '../components/ArtistsFilters'
import DialogArtist from '@/modules/admin/track-import/components/DialogArtist'

export default {
  components: {
    ArtistsFilters,
    DialogArtist
  },

  computed: {
    ...mapState('newReleasesArtists', [
      'artists',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading'
    ])
  },

  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL
    }
  },

  methods: {
    ...mapActions('newReleasesArtists', [
      'read',
      'unpublishArtist',
      'publishArtist'
    ]),
    ...mapMutations('newReleasesArtists', [
      'setMetadata',
      'setSocial',
      'setImages',
      'setPage',
      'setPageSize',
      'setOrdering',
      'setImage'
    ]),
    ...mapMutations('trackImport', ['setDialogArtist']),

    openSB(id) {
      window.open(`https://app.syncvault.com/artist/${id}`, '_blank')
    },
    insert() {
      this.setDialogArtist({ status: true, type: 'Create', id: null })
    },
    openEdit(artist) {
      this.setDialogArtist({ status: true, type: 'Edit', id: artist.id })
      if (
        artist.label !== null &&
        typeof artist.label.label_id !== 'undefined'
      ) {
        artist.label = artist.label.label_id
      }
      this.setMetadata(JSON.parse(JSON.stringify(artist)))
      this.setImage(null)
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    publish(id) {
      this.$confirm('You will publish this artist. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.publishArtist(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },
    unpublish(id) {
      this.$confirm('You will unpublish this artist. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.unpublishArtist(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Unpublish cancelled'
          })
        })
    }
  },

  created() {
    this.read()
  }
}
</script>

<style scoped>
.inline-img {
  display: inline-block;
  padding-right: 10px;
}
.gallery {
  height: 150px;
}
</style>
